
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsStyleGrid extends Serenity.EntityGrid<CsStyleRow, any> {
        protected getColumnsKey() { return CsStyleColumns.columnsKey; }
        protected getDialogType() { return CsStyleDialog; }
        protected getIdProperty() { return CsStyleRow.idProperty; }
        protected getInsertPermission() { return CsStyleRow.insertPermission; }
        protected getLocalTextPrefix() { return CsStyleRow.localTextPrefix; }
        protected getService() { return CsStyleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}